/**
 * Folks remarketing — Klaviyo events + Shopify customer identify.
 * Browse abandonment, abandoned cart, started checkout.
 */
(function () {
  'use strict';

  var cfg = window.FolksRemarketing || {};
  var recentCheckoutKeys = {};

  if (!cfg.enabled && !cfg.cartEmailCapture && !cfg.trackBrowse) return;

  function klaviyoPush(args) {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(args);
  }

  function trackKlaviyo(event, props) {
    if (!cfg.klaviyoId) return;
    klaviyoPush(['track', event, props || {}]);
  }

  function identifyEmail(email, extra) {
    if (!email) return;
    var payload = Object.assign({ email: email }, extra || {});
    if (cfg.klaviyoId) klaviyoPush(['identify', payload]);
    trackKlaviyo('Identified via Folks', payload);
  }

  function trackSavedCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      trackKlaviyo('Saved Cart', {
        $value: money(cart.total_price),
        ItemCount: cart.item_count,
        Items: (cart.items || []).map(productFromJson)
      });
    }).catch(function () {});
  }

  window.FolksRemarketing = window.FolksRemarketing || {};
  window.FolksRemarketing.identifyEmail = identifyEmail;
  window.FolksRemarketing.trackSavedCart = trackSavedCart;

  function money(cents) {
    return (Number(cents || 0) / 100).toFixed(2);
  }

  function productFromJson(p) {
    if (!p) return null;
    return {
      ProductName: p.title,
      ProductID: String(p.id),
      SKU: p.sku || p.variant_id || '',
      Categories: p.product_type ? [p.product_type] : [],
      ImageURL: p.featured_image && p.featured_image.url ? p.featured_image.url : p.image || '',
      URL: cfg.shopUrl + (p.url || ''),
      Brand: p.vendor || 'Folks',
      Price: money(p.price),
      CompareAtPrice: money(p.original_price || p.price)
    };
  }

  /* ── Browse: product page ── */
  function trackViewedProduct() {
    if (!cfg.trackBrowse) return;
    var el = document.querySelector('[data-product-json], script[type="application/json"][data-product-json]');
    var product = null;
    if (el) {
      try { product = JSON.parse(el.textContent); } catch (e) {}
    }
    if (!product && window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      var m = window.ShopifyAnalytics.meta.product;
      product = { id: m.id, title: document.title, vendor: '', product_type: '', variants: [{ id: m.variantId, price: m.price }] };
    }
    if (!product) return;

    var variant = (product.variants && product.variants[0]) || {};
    var item = {
      ProductName: product.title,
      ProductID: String(product.id),
      SKU: variant.sku || String(variant.id || ''),
      Categories: product.type || product.product_type ? [product.type || product.product_type] : [],
      ImageURL: product.featured_image || (product.media && product.media[0] && product.media[0].src) || '',
      URL: window.location.href,
      Brand: product.vendor || 'Folks',
      Price: money(variant.price),
      CompareAtPrice: money(variant.compare_at_price || variant.price)
    };

    trackKlaviyo('Viewed Product', item);
  }

  /* ── Cart events ── */
  function trackAddedToCart(cartLine) {
    var item = productFromJson(cartLine);
    if (!item) return;
    trackKlaviyo('Added to Cart', item);
  }

  function trackStartedCheckout(cart) {
    if (!cart || !cart.items) return;
    trackKlaviyo('Started Checkout', {
      $value: money(cart.total_price),
      ItemNames: cart.items.map(function (i) { return i.product_title || i.title; }),
      Items: cart.items.map(productFromJson),
      ItemCount: cart.item_count
    });
  }

  /* ── Cart drawer email capture ── */
  function bindCartEmailCapture() {
    if (!cfg.cartEmailCapture) return;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-fcd-save-cart]');
      if (!btn) return;
      e.preventDefault();
      var wrap = btn.closest('[data-fcd-save-wrap]');
      var input = wrap && wrap.querySelector('[data-fcd-save-email]');
      var msg = wrap && wrap.querySelector('[data-fcd-save-msg]');
      var email = input && input.value.trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (msg) { msg.textContent = 'Ingresá un email válido.'; msg.hidden = false; }
        return;
      }
      btn.disabled = true;
      var params = new URLSearchParams();
      params.append('form_type', 'customer');
      params.append('utf8', '✓');
      params.append('contact[email]', email);
      params.append('contact[tags]', 'newsletter,cart-save,remarketing');
      fetch('/contact', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString()
      }).then(function () {
        identifyEmail(email, { source: 'cart_drawer' });
        trackSavedCart();
        if (msg) { msg.textContent = 'Listo — te avisamos si dejás algo pendiente.'; msg.hidden = false; msg.style.color = '#1B4D35'; }
        if (input) input.disabled = true;
        btn.textContent = 'Guardado ✓';
      }).catch(function () {
        btn.disabled = false;
        if (msg) { msg.textContent = 'No pudimos guardar. Probá de nuevo.'; msg.hidden = false; }
      });
    });
  }

  /* ── Hook checkout button ── */
  function bindCheckoutTracking() {
    var handleCheckoutIntent = function () {
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart || !cart.items || !cart.items.length) return;
          var checkoutKey = 'checkout:' + cart.token + ':' + cart.item_count + ':' + cart.total_price;
          var now = Date.now();
          if (recentCheckoutKeys[checkoutKey] && now - recentCheckoutKeys[checkoutKey] < 5000) return;
          recentCheckoutKeys[checkoutKey] = now;
          trackStartedCheckout(cart);
        })
        .catch(function () {});
    };

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-fcd-checkout], [name="checkout"], a[href*="/checkout"], button[formaction*="/checkout"]');
      if (!btn) return;
      handleCheckoutIntent();
    }, true);

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action || !/\/checkout(\?|#|$)/.test(form.action)) return;
      handleCheckoutIntent();
    });
  }

  /* ── PubSub from Dawn product-form / cart-drawer ── */
  function bindPubSub() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || !event.cartData) return;
      var items = event.cartData.items || [];
      var line = items.length ? items[items.length - 1] : event.cartData;
      if (line && (line.product_id || line.id || line.variant_id)) {
        trackAddedToCart(line);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (document.body.classList.contains('template-product') || document.querySelector('.product')) {
      trackViewedProduct();
    }
    bindCartEmailCapture();
    bindCheckoutTracking();
    bindPubSub();
  });
})();
